import {faArrowRight, faCircleInfo} from '@fortawesome/pro-regular-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Flex, Space, Tooltip} from 'antd';
import {ReactElement} from 'react';

import {Text} from '../../../../../../../../component/text/text';
import {gray7} from '../../../../../../../../css/var-export.scss';
import {Locale} from '../../../../../../../../provider/locale/locale';

import {AbuseStatusBadge} from './abuse-status-badge';
import * as styles from './history-modal.scss';

type PropsType = {
    formattedDate: string | null;
    formattedTime: string | null;
    newValue: string;
    oldValue: string;
};

export function AbuseStatusLog(props: PropsType): ReactElement {
    const {formattedDate, formattedTime, oldValue, newValue} = props;

    return (
        <div>
            <Flex align="center" gap={4}>
                <Text secondary>
                    {formattedDate} {formattedTime}
                </Text>
                <Tooltip title={<Locale stringKey="REVIEWS__REVIEW_ABUSE_STATUS_UPDATED__DATE_TOOLTIP" />}>
                    <FontAwesomeIcon
                        className={styles.HistoryModal_infoIcon}
                        color={gray7}
                        fontSize={14}
                        icon={faCircleInfo}
                    />
                </Tooltip>
            </Flex>
            <Flex align="center" gap={8} wrap>
                <Text lighter stringKey="REVIEWS__REVIEW_ABUSE_STATUS_UPDATED" />
                <Space size={8} wrap>
                    <AbuseStatusBadge status={oldValue} />
                    <FontAwesomeIcon color={gray7} fontSize={16} icon={faArrowRight} />
                    <AbuseStatusBadge status={newValue} />
                </Space>
            </Flex>
        </div>
    );
}
